var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "selection-modal authentication-required-modal" },
    [
      _c("div", { staticClass: "selection-modal-content" }, [
        _c(
          "button",
          {
            staticClass: "close-button",
            attrs: { title: "Fermer" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          },
          [_c("icon", { attrs: { icon: "panier_picto_suppr" } })],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "full" }, [
          _c("div", { staticClass: "content" }, [
            _c("h2", { staticClass: "title-2 infos" }, [
              _vm._v("\n          Découvrez la plateforme\n        "),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-1" }, [
              _vm._v(
                "\n          1 minute pour découvrir les fonctionnalités de notre plateforme !\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ct ct--button cta cta-clear cta-infos",
                on: {
                  click: function ($event) {
                    return _vm.decline()
                  },
                },
              },
              [_vm._v("\n          Non merci\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ct ct--button cta cta-infos",
                on: {
                  click: function ($event) {
                    return _vm.start()
                  },
                },
              },
              [_vm._v("\n          Commencer\n        ")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }